import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { pxToRem } from '../../../assets/styles/helper';
import themeColors from '../../../assets/styles/themeColors';
import { variables } from '../../../assets/styles/variables';
import BottomDrawer from '../../Drawer/Drawer';
import Button from '../../Button/Button';

const DrawerWrapper = styled.div`
  h2 {
    color: ${themeColors.colorTextPrimary};
  }
`;

const Sections = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(20)};
  padding: ${pxToRem(8)} 0;
`;

const Section = styled.p`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: ${pxToRem(14)};
  line-height: 1.5;
  color: ${themeColors.colorTextSecondary};
  margin: 0;

  > strong {
    font-weight: 700;
    color: ${themeColors.colorTextSecondary};
  }
`;

const Footnote = styled.p`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: ${pxToRem(13)};
  line-height: 1.5;
  color: ${themeColors.colorTextSecondary};
  margin: ${pxToRem(8)} 0 0;
`;

const DrawerFooter = styled.div`
  > button {
    width: 100%;
    color: ${themeColors.colorPrimary};
    font-weight: 700;
  }
`;

const SellFromHomePreAuthDrawer = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  const footer = (
    <DrawerFooter>
      <Button variant="primaryOutlined" textTransform="none" onClick={onClose}>
        {t('sellWizard.sfhWizard.preAuthDrawer.gotIt')}
      </Button>
    </DrawerFooter>
  );

  return (
    <DrawerWrapper>
      <BottomDrawer
        isOpen={isOpen}
        onClose={onClose}
        title={t('sellWizard.sfhWizard.preAuthDrawer.title')}
        footer={footer}
        maxHeight="70%"
      >
        <Sections>
          <Section>
            <strong>
              {t('sellWizard.sfhWizard.preAuthDrawer.priceGuaranteeLabel')}
            </strong>{' '}
            {t('sellWizard.sfhWizard.preAuthDrawer.priceGuaranteeBody')}
          </Section>
          <Section>
            <strong>
              {t('sellWizard.sfhWizard.preAuthDrawer.preAuthLabel')}
            </strong>{' '}
            {t('sellWizard.sfhWizard.preAuthDrawer.preAuthBody')}
          </Section>
          <Footnote>
            {t('sellWizard.sfhWizard.preAuthDrawer.footnote')}
          </Footnote>
        </Sections>
      </BottomDrawer>
    </DrawerWrapper>
  );
};

SellFromHomePreAuthDrawer.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default SellFromHomePreAuthDrawer;
